import React, { useEffect } from "react";
import { themeStore } from "stores/themeStore.store";
import { usePermissions } from "utils/hooks/usePermissions";
import { Navigate, useLocation } from "react-router-dom";
const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  permissions = [],
  ...props
}) => {
  const { onBlankLayout } = themeStore();
  const hasPermission = usePermissions();
  const location = useLocation();

  useEffect(() => {
    const isBlank = blankLayout ? true : false;
    onBlankLayout(isBlank);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blankLayout]);
  if (permissions.length > 0 && !hasPermission(permissions)) {
    return <Navigate to="/error-page" state={{ from: location }} replace />;
  }
  return <Component {...props} />;
};

export default AppRoute;
